<template>
  <div>
    <a-modal
      :centered="true"
      :width="587"
      v-model="showModal"
      :footer="null"
      :height="!closeButton ? '100vh' : null"
      :bodyStyle="{
        padding: '24px',
        height: !closeButton ? '100vh' : null,
        display: page === 2 ? 'flex' : null,
        justifyContent: 'center',
        alignItems: 'center'
      }"
      @cancel="hide"
      :closable="closeButton && page !== 2"
    >
      <div v-if="page === 1">
        <div class="heading-container">
          <a-icon
            class="close-icon-size cp mr-3"
            type="close"
            style="font-size: 20px; color: #000000"
            @click="hide"
          />
          <p class="heading">Suggest a circle</p>
          <a-button class="apply show" @click="apply" :loading="loading">
            Send
          </a-button>
        </div>
        <p class="sub-heading">Name of condition</p>
        <a-input
          placeholder="Enter condition name"
          v-model="circle_name"
          class="input-field"
        ></a-input>
        <p class="sub-heading">Description</p>
        <a-textarea
          placeholder="Reason for suggesting this circle"
          v-model="description"
          :autosize="{ minRows: 5, maxRows: 5 }"
          :maxLength="2000"
          class="input-field"
          style="margin: 0px"
        ></a-textarea>
        <div class="count">{{ description ? description.length : 0 }}/2000</div>
        <div class="footer">
          <a-button class="apply" @click="apply" :loading="loading">
            Send
          </a-button>
        </div>
      </div>
      <div v-if="page === 2" class="d-flex align-items-center flex-column">
        <img
          class="success-check-img"
          src="../../assets/images/success-check-img.png"
          alt="success-image"
        />
        <p class="title" style="text-align: center">
          Thank you for<br class="show_not" />
          suggesting a circle!
        </p>
        <p
          class="subtitle"
          style="width: 100%; min-width: 300px; max-width: 581px; text-align: center; margin-bottom: 24px"
        >
          DoveMed will review your submission and inform you once the<br
            class="show_not"
          />
          circle is live.
        </p>
        <button class="continue-button" @click="hide">Continue</button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { faBookOpen } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { RepositoryFactory } from "../../repositories/RepositoryFactory";

library.add(faBookOpen);

const UserRepository = RepositoryFactory.get("user");

export default {
  name: "SuggestCircleModal",
  props: {
    atSuccess: Function
  },
  data() {
    return {
      showModal: false,
      circle_name: "",
      description: "",
      closeButton: true,
      page: 1,
      loading: false
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      if (window.innerWidth < 700) {
        this.closeButton = false;
      } else {
        this.closeButton = true;
      }
    },
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
      this.circle_name = "";
      this.description = "";
      this.page = 1;
    },
    apply() {
      if (!this.circle_name.trim().length) {
        this.$notification.error({
          message: "Error",
          description: "Please enter condition name"
        });
      } else if (!this.description.trim().length) {
        this.$notification.error({
          message: "Error",
          description: "Please enter reason for suggesting this circle"
        });
      } else {
        this.loading = true;
        const payload = {
          user_id: this.authUser.user.id,
          condition_type: this.circle_name,
          reason: this.description
        };
        UserRepository.suggestCircle(payload)
          .then(res => {
            this.atSuccess();
            this.page = 2;
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            this.$notification.error({
              message: "Error",
              description:
                `${error.response.data.message}`
            });
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.heading-container {
  display: flex;
  align-items: center;
  padding-bottom: 28px;
  .heading {
    font-family: "Lato";
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    color: #33415f;
    flex: 1;
    margin-bottom: 0px;
    @media screen and (min-width: 701px) {
      font-size: 24px;
      line-height: 32px;
    }
  }
  .close-icon-size {
    @media screen and (min-width: 701px) {
      display: none;
    }
  }
}
.sub-heading {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #647490;
}
.input-field {
  height: 56px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 16px;
  line-height: 32px;
  color: #0f1734;
  margin-bottom: 24px;
}
.count {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  color: #94a3b8;
}
.footer {
  margin-top: 48px;
  display: flex;
  justify-content: flex-end;
  @media screen and (max-width: 700px) {
    display: none;
  }
}
.apply {
  padding: 12px 24px;
  border-radius: 6px;
  border: none;
  color: #ffffff;
  background-color: #2a71d4;
  font-weight: 700;
  font-size: 14px;
}
.success-check-img {
  margin-bottom: 29px;
  min-width: 68px;
  height: 68px;
  background-size: cover;
}
.title {
  font-family: "Lato";
  font-weight: 700;
  font-size: 32px;
  color: #0f1734;
  margin: 0px;
}
.subtitle {
  font-family: "Lato";
  font-weight: 400;
  font-size: 16px;
  color: #647490;
  margin-top: 8px;
  margin-bottom: 35px;
}
.continue-button {
  width: 106px;
  height: 48px;
  border-radius: 6px;
  border: none;
  text-align: center;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #ffffff;
  background-color: #2a71d4;
  cursor: pointer;
}
.show {
  @media screen and (min-width: 701px) {
    display: none;
  }
}
.show_not {
  @media screen and (max-width: 700px) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/SuggestCircleModal.vue